import { gql } from '../../utils/helper';

export const createPublicationNavigationMenuItem = gql`
  mutation createPublicationNavigationMenuItem($object: publicationNavigationMenuItems_insert_input!) {
    insert_publicationNavigationMenuItems_one(object: $object) {
      id
    }
  }
`;

export const organizeMenuItems = (orderedMenuIds: string[]): string => {
  const query = `
        mutation reorderMenuItems {
          ${orderedMenuIds
      .map((menuId, index) => {
        return `
              menu${index}: update_publicationNavigationMenuItems_by_pk(_set: { order: ${index + 1
          } }, pk_columns: { id: "${menuId}" }) {
                id
                order
              }
            `;
      })
      .join('')}
        }
      `;

  return gql`
    ${query}
  `;
};

export const updatePublicationBrandings = gql`
  mutation updatePublicationBrandings($id: uuid!, $set: publicationBrandings_set_input!) {
    update_publicationBrandings_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      idleBackgroundColor
      activeBackgroundColor
      activeFontColor
      createdAt
      enableLogoNavigation
      fontStyle
      idleFontColor
      isNavigationMenuSticky
      logoUrl
      publicationId
      showLogoOnFooter
      updatedAt
      enableGoogleTranslate
    }
  }
`;

export const deleteNavigationMenuById = gql`
  mutation deleteNavigationMenuById($id: uuid!) {
    delete_publicationNavigationMenuItems(where: { id: { _eq: $id } }) {
      affected_rows
      returning {
        publicationId
      }
    }
  }
`;

export const getStoriesForSelectedMenuId = gql`
  query publicationNavigationMenuStories($id: uuid!) {
    menuStories: publicationNavigationMenuStories(where: { menuId: { _eq: $id } }, order_by: { order: asc }) {
      order
      menuId
      id
      displayName
      createdBy
      createdAt
      storyId
      updatedAt
      story {
        _id
        order
        title
      }
    }
  }
`;

export const organizeMenuStoriesList = (storyIds: string[]): string => {
  const query = `
        mutation reorderMenuStoriesList {
          ${storyIds
      .map((menuStoryId, index) => {
        return `
              story${index}: update_publicationNavigationMenuStories_by_pk(_set: { order: ${index + 1
          } }, pk_columns: { id: "${menuStoryId}" }) {
                id
                order
              }
            `;
      })
      .join('')}
        }
      `;

  return gql`
    ${query}
  `;
};

export const deleteNavigationMenuStoryById = gql`
  mutation deleteNavigationMenuStoryById($id: uuid!) {
    delete_publicationNavigationMenuStories(where: { id: { _eq: $id } }) {
      affected_rows
      returning {
        id
      }
    }
  }
`;

export const updateMenuStoryNameById = gql`
  mutation updateMenuStoryNameById($id: uuid!, $displayName: String) {
    update_publicationNavigationMenuStories(where: { id: { _eq: $id } }, _set: { displayName: $displayName }) {
      affected_rows
      returning {
        id
      }
    }
  }
`;

export const updateMenuTitleById = gql`
  mutation updateMenuTitleById($id: uuid!, $title: String) {
    update_publicationNavigationMenuItems(where: { id: { _eq: $id } }, _set: { title: $title }) {
      affected_rows
      returning {
        id
      }
    }
  }
`;
export const updatePublicationTocSettings = gql`
  mutation updatePublicationTocSettings($id: uuid!, $set: publicationTOCSettings_set_input!) {
    update_publicationTOCSettings_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
      columnLayoutNumber
      createdBy
      headerHeightSize
      headerImageUrl
      menuTitle
      pageTitle
      showTableOfContents
      createdAt
      publicationId
      updatedAt
      description
      hasUserToggledToc
    }
  }
`;

export const updatePublication = gql`
  mutation updatePublication($id: uuid!, $data: publications_set_input!) {
    resource: update_publications_by_pk(pk_columns: { id: $id }, _set: $data) {
      id
      publicUrl
    }
  }
`;

export const createPublicationStoryPdfSettings = gql`
  mutation createPublicationStoryPdfSettings($object: publicationStoryPdfSettings_insert_input!) {
    resource: insert_publicationStoryPdfSettings_one(object: $object) {
      id
    }
  }
`;

export const updatePublicationStoryPdfSettings = gql`
  mutation updatePublicationStoryPdfSettings($id: uuid!, $set: publicationStoryPdfSettings_set_input!) {
    resource: update_publicationStoryPdfSettings_by_pk(pk_columns: { id: $id }, _set: $set) {
      id
    }
  }
`;

export const getPublicationStoryPdfSettings = gql`
  query getPublicationStoryPdfSettings($publicationId: uuid!) {
    publicationStoryPdfSettings: publicationStoryPdfSettings(where: { publicationId: { _eq: $publicationId } }) {
      storyId
      storyContentsHtml
      id
      publicationId
    }
  }
`;

export const deletePublicationStoryPdfSettings = gql`
  mutation deletePublicationStoryPdfSettings($id: uuid!) {
    resource: delete_publicationStoryPdfSettings(where: { id: { _eq: $id } }) {
      affected_rows
    }
  }
`;

export const getPublicationWithSectionsAndStories = gql`
  fragment storyFolderFields on storyFolders {
    id
    title
    order
    parentFolderId
    stories(where: {deletedAt: {_is_null: true}, state: {_in: $state}}, order_by: {order: asc}) {
      id: _id
      title
      order
    }
}

query getPublicationById($publicationId: uuid!, $entityId: Int!, $state: [storyStates_enum!]) {
  publicationRootFolder: storyFolders(where: {publicationId: {_eq: $publicationId}, entityId: {_eq: $entityId}, parentFolder: {parentFolderId: {_is_null: true}}}) {
    ...storyFolderFields
  }
  publication: publications_by_pk(id: $publicationId) {
    id
    status
    title
    description
    updatedAt
    customCssCode
    publicUrl
    publicationFolders: storyFolders(
      where: {
        publicationId: { _eq: $publicationId }, entityId: { _eq: $entityId }, deletedAt: { _is_null: true }
      }
    )
    { ...storyFolderFields, subFolders(where: {deletedAt: {_is_null: true}}) {
          ...storyFolderFields
      }
    }
  }
}

`;

export const getSectionAndStoriesHeirarchy = gql`
  fragment storyFolderFields on storyFolders {
    id
    title
    order
    parentFolderId
    stories(where: {deletedAt: {_is_null: true}, state: {_in: $state}}, order_by: {order: asc}) {
      id: _id
      title
      order
    }
}

query getStoryFolderById($sectionId: uuid!, $entityId: Int!, $state: [storyStates_enum!]) {
  storyFolders(where: {id: {_eq: $sectionId}, entityId: {_eq: $entityId}}) {
    ...storyFolderFields, subFolders(where: {deletedAt: {_is_null: true}}) {
      ...storyFolderFields, subFolders(where: {deletedAt: {_is_null: true}}) {
        ...storyFolderFields, subFolders(where: {deletedAt: {_is_null: true}}) {
          ...storyFolderFields, subFolders(where: {deletedAt: {_is_null: true}}) {
            ...storyFolderFields, subFolders(where: {deletedAt: {_is_null: true}}) {
              ...storyFolderFields, subFolders(where: {deletedAt: {_is_null: true}}) {
                ...storyFolderFields
              }
            }
          }
        }
      }
    }
  }
}

`;

export const getStoryWithContent = gql`
  query getStoryWithContent($storyId: String!) {
    stories(where: { _id: { _eq: $storyId } }) {
      _id
      title
      description
      state
      customCssCode
      contents {
        _id
        active
        content
        contentHtml
        createdAt
        description
        entityId
        format
        group
        layout
        order
        storyId
        title
        type
        updatedAt
        authorId
        author {
          _id
          email
          firstName
          lastName
          opengovId
        }
        contentChartConfig {
          id
          contentId
          storyId
          config
          type
        }
      }
    }
  }
`;

export const updatePublicationCustomCssCode = gql`
  mutation updatePublicationCustomCssCode($id: uuid!, $customCssCode: String) {
    publication: update_publications_by_pk(pk_columns: { id: $id }, _set: { customCssCode: $customCssCode }) {
      id
      customCssCode
    }
  }
`;

export const updateStoryCustomCssCode = gql`
  mutation updateStoryCustomCssCode($id: String!, $customCssCode: String!) {
    story: update_stories_by_pk(pk_columns: { _id: $id }, _set: { customCssCode: $customCssCode }) {
      _id
      customCssCode
    }
  }
`;
export const deleteStoryEmbedsByViewId = gql`
  mutation deleteStoryEmbedsByViewId($embedIds: [uuid!]) {
    delete_storyEmbeds(where: { embedId: { _in: $embedIds } }) {
      affected_rows
      returning {
        embedId
      }
    }
  }
`;

export const deleteStoryEmbedByStoryAndEmbedId = (contentIds: { storyId: string; embedId: string }[]): string => {
  const query = `
    mutation deleteStoryEmbedByStoryAndEmbedId {
      ${contentIds
      .map((contentId, index) => {
        return `
          storyEmbed${index}: delete_storyEmbeds_by_pk(storyId: "${contentId.storyId}", embedId: "${contentId.embedId}") {
            embedId
          }
            `;
      })
      .join('')}
      }
  `;
  return gql`
    ${query}
  `;
};

export const getStoryEmbedsByViewId = gql`
  query getStoryEmbedsByViewId($embedIds: [uuid!]) {
    storyEmbeds(where: { embedId: { _in: $embedIds } }) {
      storyId
      embedId
      reportId
      type
      updatedAt
      savedViewId
    }
  }
`;

export const deleteStoryContentByIds = (contentIds: string[]): string => {
  const query = `
    mutation deleteStoryContentByIds($active: Boolean!) {
      ${contentIds
      .map((contentId, index) => {
        return `
              storyContent${index}: delete_storyContents(
                  where: { _id: {_eq: "${contentId}"}, active: {_eq: $active} }
                ) {
                affected_rows
                returning {
                  _id
                }
              }
            `;
      })
      .join('')}
      }
  `;
  return gql`
    ${query}
  `;
};

export const updateStoryContentByIds = (data: { id: string; content: string }[]): string => {
  const query = `
    mutation updateStoryContentByIds {
      ${data
      .map((item, index) => {
        return `
              storyContent${index}: update_storyContents(
                where: { _id: {_eq: "${item.id}"}},
                _set: {content: ${item.content}, contentHtml: ${item.content}}
              ) {
                affected_rows
                returning {
                  _id
                }
              }
            `;
      })
      .join('')}
      }
  `;
  return gql`
    ${query}
  `;
};

export const updateStoryEmbedsFrequencyByViewId = gql`
  mutation updateStoryEmbedsFrequencyByViewId($embedIds: [uuid!], $frequency: String) {
    update_storyEmbeds(where: { embedId: { _in: $embedIds } }, _set: { frequency: $frequency }) {
      affected_rows
      returning {
        savedViewId
      }
    }
  }
`;

export const updateStoryEmbedByStoryAndEmbedId = (
  contents: { storyId: string; embedId: string }[],
  frequency: string
): string => {
  const query = `
    mutation updateStoryEmbedByStoryAndEmbedId {
      ${contents
      .map((content, index) => {
        return `
            storyEmbed${index}: update_storyEmbeds_by_pk(pk_columns:
            {
              storyId: "${content.storyId}", embedId: "${content.embedId}"},
              _set: {frequency: "${frequency}", updatedAt: "${new Date().toISOString()}"
            }) {
              embedId
            }
        `;
      })
      .join('')}
    }
  `;
  return gql`
    ${query}
  `;
};

export const getEmbedDataQuery = (values: { storyId: string; embedId: string }[]): string => {
  const query = `
    query fetchEmbedData {
      ${values
      .map((contentId, index) => {
        return `
          storyEmbed${index}: storyEmbeds(where: {storyId: {_eq: "${contentId.storyId}"}, embedId: {_eq: "${contentId.embedId}"}}) {
            storyId
            embedId
            reportId
            type
            updatedAt
            savedViewId
          }
            `;
      })
      .join('')}
      }
  `;
  return gql`
    ${query}
  `;
};

export const getStoryDetailsForSetupPDF = gql`
  query getStoryDetailsForSetupPDF($id: String!) {
    storyData: stories_by_pk(_id: $id) {
      _id
      entityId
      title
      description
      customCssCode
      isFollowable
      settings {
        fontsHeadline
        fontsParagraph
      }
      contents {
        content
        contentHtml
        _id
        order
        title
        description
        active
        type
        contentChartConfig {
          id
          contentId
          storyId
          config
          type
        }
      }
      folder {
        publication {
          customCssCode
        }
      }
    }
  }
`;

export const upsertSetupPdfStyles = gql`
  mutation upsertSetupPdfStyles($object: exportPdfSettings_insert_input!) {
    resource: insert_exportPdfSettings_one(
      object: $object
      on_conflict: {
        constraint: exportPdfSettings_exportType_exportId_key
        update_columns: [
          coverStoryId
          pageMargins
          headerControls
          footerControls
          tocStyles
          tocData
          watermark
          storyStates
        ]
      }
    ) {
      id
      exportType
      exportId
      coverStoryId
      pageMargins
      headerControls
      footerControls
      tocStyles
      tocData
      watermark
      storyStates
    }
  }
`;

export const updateSectionContentWithId = gql`
  mutation updateSectionContentWithId($id: String!, $content: String!, $contentHtml: String!) {
    update_storyContents(where: { _id: { _eq: $id } }, _set: { content: $content, contentHtml: $contentHtml }) {
      affected_rows
    }
  }
`;

export const fetchStoryContent = gql`
  query fetchStoryContent($storyId: String!, $contentSubstring: String!) {
    storyContent: storyContents(
      where: {
        storyId: { _eq: $storyId }
        content: { _ilike: $contentSubstring }
        contentHtml: { _ilike: $contentSubstring }
      }
    ) {
      _id
      content
      contentHtml
    }
  }
`;
